import { InputNumber } from 'antd';

interface BufferTimeProps {
  bufferMin: number;
  timeslotDays: number;
  handleBufferMinChange: (value: number | null) => void;
  handleTimeslotDaysChange: (value: number | null) => void;
}

const BufferTime = ({
  bufferMin,
  timeslotDays,
  handleBufferMinChange,
  handleTimeslotDaysChange,
}: BufferTimeProps) => {
  return (
    <div className="mt-8">
      <div className="flex gap-4 items-center mb-4">
        <label className="font-bold">Buffer Minutes:</label>
        <InputNumber
          min={5}
          max={20}
          value={bufferMin}
          onChange={handleBufferMinChange}
          className="w-24"
        />
      </div>
      <div className="flex gap-4 items-center mb-4">
        <label className="font-bold">Timeslot Days:</label>
        <InputNumber
          min={7}
          max={120}
          value={timeslotDays}
          onChange={handleTimeslotDaysChange}
          className="w-24"
        />
      </div>
    </div>
  );
};

export default BufferTime;
